import {lazy} from 'react'
import {Routes, Route, Navigate} from 'react-router-dom'

// lazy load all routes
const RouteUpload = lazy(() => import('../features/uploads/routes/upload'))
const RouteGraph = lazy(() => import('../features/graph/routes/graph'))
const RouteVideoLab = lazy(() => import('../features/videolab/routes/videolab'))
const RouteUsers = lazy(() => import('../features/auth/routes/users'))
const RouteCompare = lazy(() => import('../features/compare/routes/compare'))
const RouteChat = lazy(() => import('../features/chat/routes/chat'))
const RouteAsk = lazy(() => import('../features/semantic-browse/routes/ask'))
const RouteApiViewers = lazy(() => import('../features/api-viewers/routes/api-viewers'))
const RoutePlots = lazy(() => import('../features/plots/routes/plots'))
const RouteDashboard = lazy(() => import('../features/dashboard/routes/metabase'))
const RoutePlotsChartJS = lazy(() => import('../features/plots/routes/chartjs'))
const RouteExpressions = lazy(() => import('../features/expressions/routes/expressions'))
const RouteMixer = lazy(() => import('../features/mixer/routes'))
const RouteVideoEditor = lazy(() => import('../features/video-editor/routes'))

const RouteTest = lazy(() => import('../features/dev-test/routes'))

const RouteBYO = lazy(() => import('../features/browse/routes/byo'))
const RouteLibraryDetails = lazy(() => import('../features/browse/routes/details'))
const RouteVionverse = lazy(() => import('../features/legacy/routes/vionverse'))

export function AppRoutes() {
  return (
    <Routes>
      <Route
        path='*'
        element={
          <Navigate
            to='/'
            replace
          />
        }
      />
      <Route
        path='/'
        element={<RouteUpload />}
      />
      <Route
        path='/users'
        element={<RouteUsers />}
      />
      <Route
        path='/graph'
        element={<RouteGraph />}
      />
      <Route
        path='/videolab'
        element={<RouteVideoLab />}
      />
      <Route
        path='/videolab/:assetID'
        element={<RouteVideoLab />}
      />
      <Route
        path='/compare'
        element={<RouteCompare />}
      />
      <Route
        path='/compare/:assetID'
        element={<RouteCompare />}
      />
      <Route
        path='/chat'
        element={<RouteChat />}
      />
      <Route
        path='/ask'
        element={<RouteAsk />}
      />
      <Route
        path='/dashboard'
        element={<RouteDashboard />}
      />
      <Route
        path='/api-viewers'
        element={<RouteApiViewers />}
      />
      <Route
        path='/plots'
        element={<RoutePlots />}
      />
      {/* <Route path='/plots/pixi' element={<RoutePlotsPixi />} /> */}
      <Route
        path='/plots/chartjs'
        element={<RoutePlotsChartJS />}
      />
      <Route
        path='/expressions'
        element={<RouteExpressions />}
      />
      <Route
        path='/vionmix'
        element={
          <Navigate
            to='/browse'
            replace
          />
        }
      />
      <Route
        path='/browse'
        element={<RouteMixer />}
      />
      <Route
        path='/montage'
        element={<RouteVideoEditor />}
      />

      {process.env.NODE_ENV === 'development' ?
        <Route
          path='/test'
          element={<RouteTest />}
        />
      : undefined}

      {/* legacy apps */}
      <Route
        path='/library'
        element={<RouteBYO />}
      />
      <Route
        path='/library/:assetID'
        element={<RouteLibraryDetails />}
      />
      <Route
        path='/embed/library/:assetID'
        element={<RouteLibraryDetails isEmbedded />}
      />
      <Route
        path='/embed/library/:assetID/:pathSegments'
        element={<RouteLibraryDetails isEmbedded />}
      />
      <Route
        path='/vionverse'
        element={<RouteVionverse />}
      />
    </Routes>
  )
}
